export default "__VITE_ASSET__B8qfjg6M__"